import { isAccessibilityMode, onAccessibilityModeChange } from "./accessibility";
import { playUiClick } from "../audio/sfx";
const ARROW_BTN = "fixed z-40 w-11 h-11 rounded-full bg-slate-800/80 text-slate-200 hover:bg-slate-700 flex items-center justify-center text-lg shadow-lg border-0";
const ZOOM_BTN = "w-11 h-11 rounded-full bg-slate-800/80 text-slate-200 hover:bg-slate-700 flex items-center justify-center text-xl shadow-lg border-0";
function arrowButton(symbol, positionClasses) {
    const btn = document.createElement("button");
    btn.type = "button";
    btn.title = "Karte verschieben";
    btn.textContent = symbol;
    btn.className = `${ARROW_BTN} ${positionClasses}`;
    return btn;
}
// Pointer capture keeps 'pointerup'/'pointercancel' firing on this element even if the finger/
// cursor drifts off it while held — avoids a "stuck held" button that never receives its release.
function wireHold(btn, start, stop) {
    btn.addEventListener("pointerdown", (e) => {
        const pe = e;
        pe.preventDefault();
        playUiClick();
        btn.setPointerCapture(pe.pointerId);
        start();
    });
    btn.addEventListener("pointerup", stop);
    btn.addEventListener("pointercancel", stop);
}
export function mountAccessibilityControls(hooks) {
    const container = document.createElement("div");
    document.body.appendChild(container);
    const up = arrowButton("▲", "top-3 left-1/2 -translate-x-1/2");
    const down = arrowButton("▼", "bottom-3 left-1/2 -translate-x-1/2");
    const left = arrowButton("◀", "left-3 top-1/2 -translate-y-1/2");
    const right = arrowButton("▶", "right-3 top-1/2 -translate-y-1/2");
    const zoomWrap = document.createElement("div");
    zoomWrap.className = "fixed z-40 bottom-6 right-6 flex flex-col gap-2";
    const zoomIn = document.createElement("button");
    zoomIn.type = "button";
    zoomIn.title = "Vergrößern";
    zoomIn.textContent = "+";
    zoomIn.className = ZOOM_BTN;
    const zoomOut = document.createElement("button");
    zoomOut.type = "button";
    zoomOut.title = "Verkleinern";
    zoomOut.textContent = "−";
    zoomOut.className = ZOOM_BTN;
    zoomWrap.append(zoomIn, zoomOut);
    container.append(up, down, left, right, zoomWrap);
    const held = { up: false, down: false, left: false, right: false };
    const reportPan = () => {
        const dx = (held.right ? 1 : 0) - (held.left ? 1 : 0);
        const dy = (held.down ? 1 : 0) - (held.up ? 1 : 0);
        hooks.onPanChange(dx, dy);
    };
    wireHold(up, () => {
        held.up = true;
        reportPan();
    }, () => {
        held.up = false;
        reportPan();
    });
    wireHold(down, () => {
        held.down = true;
        reportPan();
    }, () => {
        held.down = false;
        reportPan();
    });
    wireHold(left, () => {
        held.left = true;
        reportPan();
    }, () => {
        held.left = false;
        reportPan();
    });
    wireHold(right, () => {
        held.right = true;
        reportPan();
    }, () => {
        held.right = false;
        reportPan();
    });
    const zoomHeld = { in: false, out: false };
    const reportZoom = () => {
        hooks.onZoomChange(zoomHeld.in ? 1 : zoomHeld.out ? -1 : 0);
    };
    wireHold(zoomIn, () => {
        zoomHeld.in = true;
        reportZoom();
    }, () => {
        zoomHeld.in = false;
        reportZoom();
    });
    wireHold(zoomOut, () => {
        zoomHeld.out = true;
        reportZoom();
    }, () => {
        zoomHeld.out = false;
        reportZoom();
    });
    const applyVisibility = (enabled) => {
        container.style.display = enabled ? "" : "none";
        if (!enabled) {
            held.up = held.down = held.left = held.right = false;
            zoomHeld.in = zoomHeld.out = false;
            hooks.onPanChange(0, 0);
            hooks.onZoomChange(0);
        }
    };
    applyVisibility(isAccessibilityMode());
    onAccessibilityModeChange(applyVisibility);
}
